const instances = {
    "NDCS_SC": {
        name: 'NDCS_SC',
        domain:"dainsta.com"
    },
    '8XPARTS_SC': {
        name: '8XPARTS_SC',
        domain:"8xparts.com"
    },
    "PIPL_SC":{
        name:'PIPL_SC',
        domain:'precilayer.com',
    }
};

export const allInstanceData = {
    '_8xParts': '8XPARTS_SC',
    'NDCS': 'NDCS_SC',
    'PIPL': 'PIPL_SC'
};


const name = process.env.REACT_APP_INSTANCE_NAME || 'NDCS_SC';

export const currentInstance = instances[name];